import { createAsyncThunk } from "@src/store";
import {
  markCartTesterEditedByUser,
  setCartTesterProducts,
} from "@src/store/slices/checkoutBlocks";
import { getCartTesterProducts } from "@src/store/slices/checkoutBlocks/selectors";
import { CartTesterProduct } from "@src/store/slices/checkoutBlocks/types";
import {
  closeProductPicker,
  getProductPickerData,
  getProductPickerProducts,
  getProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";

export const saveCartTesterProductPicker = createAsyncThunk<void, void>(
  "productPicker/saveCartTesterProductPicker",
  (_, { dispatch, getState }) => {
    const data = getProductPickerData(getState());
    if (data?.type !== "cartTester") return;

    const { variationId } = data;
    const selectedProducts = getProductPickerSelectedProducts(getState());
    const allProducts = getProductPickerProducts(getState());
    const productsMap = new Map(allProducts.map((p) => [p.id, p]));

    // Preserve subscription toggles the merchant set before saving
    const existingSubscriptionByVariant = new Map(
      getCartTesterProducts(variationId)(getState()).map((p) => [
        p.variantId,
        p.isSubscription,
      ])
    );

    const cartProducts: CartTesterProduct[] = [];

    selectedProducts.forEach((selectedProduct) => {
      const product = productsMap.get(selectedProduct.id);
      const allVariants = product?.variants ?? [];
      const selectedVariantIds = selectedProduct.selectedVariantIds ?? [];
      const noVariantsSpecified = selectedVariantIds.length === 0;
      const requiresSellingPlan = product?.requiresSellingPlan;

      allVariants.forEach((variant) => {
        if (noVariantsSpecified || selectedVariantIds.includes(variant.id)) {
          cartProducts.push({
            id: selectedProduct.id,
            title: selectedProduct.title,
            image: selectedProduct.image,
            variantId: variant.id,
            variantTitle: variant.title,
            selectedOptions: variant.selectedOptions,
            price: variant.price,
            requiresSellingPlan,
            sellingPlanGroupCount: product?.sellingPlanGroupCount,
            isSubscription:
              existingSubscriptionByVariant.get(variant.id) ??
              Boolean(requiresSellingPlan),
          });
        }
      });
    });

    dispatch(setCartTesterProducts({ variationId, products: cartProducts }));
    dispatch(markCartTesterEditedByUser({ variationId }));
    dispatch(closeProductPicker());
  }
);
